import React, { useEffect, useState } from "react";
import back from "../../assets/images/back.png";
import "../../assets/styles/mobile/mobilesidebar.scss";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { set_all_items } from "../../redux/actions/AllItemsAction";
import { apiJson } from "../../Api";
import { toast } from "react-toastify";
import ItemsCategory from "../../components/customer/AllItems/ItemsCategory";
import { replaceAt } from "../../utils/utils";
import LanguagePopup from "./LanguagePopup";
import { set_country, set_direction } from "../../redux/actions/LayoutAction";
import { useHistory, useLocation } from "react-router-dom";

function MobileSidebar(props) {
  const { t, i18n } = useTranslation();
  const [langPopup, setLangPopup] = useState(false);

  const history = useHistory();
  const location = useLocation();

  let message = "";

  const options = [
    {
      label: t("my-account-logged-in.language"),
      onClick: () => setLangPopup(true),
    },
    {
      label: "Track Order",
      path: "/" + props.countryUrl + "-" + props.language + "/orders",
    },
    {
      label: "Cards & Account",
      path: "/" + props.countryUrl + "-" + props.language + "/payments",
    },
    {
      label: t("side-bar-desktop.profile"),
      path: "/" + props.countryUrl + "-" + props.language + "/profile",
    },
    {
      label: "Customer Care",
      path: "//api.whatsapp.com/send?phone=971543064845&amp;text=Hi, I need assistance",
    },
  ];

  useEffect(() => {
    apiJson.allitems.getCategories(props.countryId).then((response) => {
      if (response.success) {
        props.set_all_items({
          category: response.data,
        });
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : t("errors.wrong")
          : t("errors.wrong");
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : t("errors.wrong");
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : t("errors.wrong")
            : t("errors.wrong");
          showError();
        }
      }
    });
  }, []);

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(
      lang.toLowerCase() === "English".toLowerCase() ? "en" : "ar"
    );
    props.set_direction(
      lang.toLowerCase() === "English".toLowerCase() ? "en" : "ar"
    );
    history.push({
      pathname:
        "/" +
        props.countryUrl +
        "-" +
        (lang.toLowerCase() === "English".toLowerCase() ? "en" : "ar") +
        "/" +
        window.location.pathname.replace(/(?:.*?\/){2}/, ""),
      state: location.state,
    });
  };

  useEffect(() => {
    let categories = "";
    const selectedCat = props.selectedCat;

    if (selectedCat && selectedCat.length > 0) {
      categories = selectedCat
        .map((cat) => `&filter_by_category[]=${cat}`)
        .join("");
    }

    const basePath = window.location.pathname;

    if (categories) {
      props.set_all_items({
        selectedCat: "",
      });

      window.location.href =
        `${basePath.replace("/sidebar", "")}/items/products` +
        replaceAt(encodeURI(categories), 0, "?");

      props.set_all_items({
        selectedCat: "",
      });
    }
  }, [props.selectedCat]);

  return (
    <div className="mobile-sidebar">
      <div className="mobile-sidebar-header">
        <h6 className="menu-title">MENU</h6>
        {/* <img src={back} alt="back" onClick={() => window.history.back()} /> */}
        <FaChevronRight
        color="lightgray"
        />
      </div>

      {!localStorage.getItem("access_token") && (
        <div className="mobile-sidebar-buttons">
          <Link to="/signup" className="btn-register">
            Register
          </Link>

          <Link to="/login" className="btn-signin">
            Sign In
          </Link>
        </div>
      )}

      <div>
        {options.map((item) =>
          item.path ? (
            <a href={item.path}>
              <div className="divider">{item.label}</div>
            </a>
          ) : (
            <div className="divider" onClick={item.onClick}>
              {item.label}
            </div>
          )
        )}
      </div>
      <div className="divider">
        <h6>Shop By Categories</h6>
        <div className="categories">
          <ItemsCategory
            items={props.items}
            categories={props.category}
            selectedCat={(title) => {
              props.set_all_items({
                selectedCat: title,
              });
            }}
          />
        </div>
      </div>

      {langPopup && (
        <LanguagePopup
          onClose={(val) => setLangPopup(val)}
          setLanguage={(name) => {
            changeLanguage(name);
          }}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    country: state.language.country,
    language: state.language.language,
    countryUrl: state.language.countryUrl,
    items: state.allItems.items,
    countryId: state.language.countryId,
    selectedCat: state.allItems.selectedCat,
    category: state.allItems.category,
    coutriesList: state.language.coutriesList,
  };
};

const mapDispatchToProps = {
  set_all_items,
  set_country,
  set_direction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileSidebar);
